/**
 * Created by Kotkin on 28.09.17.
 */

import TabJSControl from './tab-js-control';

export default TabJSControl;
